<template>
  <v-dialog v-model="show" fullscreen>
    <v-card flat>
      <v-container fluid style="padding-bottom:100px">
        <div class="dialog-toolbar">
          <v-col cols="9" md="11">
            <h3>{{ dialogTitle }}</h3>
          </v-col>
          <v-col cols="1" md="1" class="pull-right-on-desktop">
            <v-icon
              @click="$emit('close-dialog')"
              style="transform: translateX(-15px)"
              >close</v-icon
            >
          </v-col>
        </div>

        <div style="height: 50px;"></div>
        <v-row>
          <v-col cols="12" md="6" offset-md="3">
            <v-row style="margin:0">
              <v-col cols="12">
                <h4 style="margin-top:6px">Tipo</h4>
              </v-col>
              <v-col cols="12">
                <v-radio-group
                  style="margin:0; font-size: 14px;"
                  v-model="currentCharge.category_charge"
                >
                  <v-row>
                    <v-col
                      v-for="(item, i) in categoryChoices"
                      :key="i"
                      cols="6"
                      md="6"
                      style="padding-bottom:0;"
                    >
                      <v-radio
                        color="rapired"
                        :label="item.text"
                        :key="i"
                        :value="item.value"
                      ></v-radio>
                    </v-col>
                  </v-row>
                </v-radio-group>
              </v-col>

              <v-col cols="12">
                <h4 style="margin-top:6px">Descripción</h4>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="currentCharge.description"
                  :error="$v.currentCharge.description.$error"
                  @input="$v.currentCharge.description.$touch()"
                  :error-messages="descriptionErrors"
                  :rows="1"
                  auto-grow
                  style="margin-top:0;padding-top:0"
                ></v-textarea>
              </v-col>

              <v-col cols="12">
                <h4 style="margin-top:6px">Monto</h4>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="currentCharge.amount"
                  :error="$v.currentCharge.amount.$error"
                  @input="$v.currentCharge.amount.$touch()"
                  :error-messages="amountErrors"
                  type="number"
                  prefix="$"
                  style="margin-top:0;padding-top:0"
                ></v-text-field>
              </v-col>

              <v-col cols="12" style="display:flex;justify-content:center;">
                <v-btn
                  :disabled="saveButtonDisabled"
                  color="secondary"
                  @click="saveCharge"
                  >GUARDAR COBRO</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import { required, numeric } from "vuelidate/lib/validators";

export default {
  props: {
    show: Boolean,
    charge: Object,
    isNewCharge: Boolean
  },
  data() {
    return {
      currentCharge: {
        id: null,
        category_charge: 0,
        request_technician: null,
        description: null,
        amount: null
      },
      categoryChoices: [
        { text: "Mano de obra", value: 0 },
        { text: "Insumo", value: 1 }
      ]
    };
  },
  created() {
    if (this.charge.id) {
      this.currentCharge = { ...this.charge };
    } else {
      this.currentCharge = { ...this.currentCharge, ...this.charge };
    }
  },
  validations() {
    const validations = {
      currentCharge: {
        category_charge: { required },
        description: { required },
        amount: { required, numeric }
      }
    };
    return validations;
  },
  computed: {
    saveButtonDisabled: function() {
      if (
        !this.currentCharge.category_charge === null ||
        !this.currentCharge.description ||
        !this.currentCharge.amount
      )
        return true;
      return false;
    },
    dialogTitle: function() {
      if (!this.charge.id) return "Nuevo cobro";
      return "Editar cobro";
    },
    descriptionErrors: function() {
      const errors = [];
      if (!this.$v.currentCharge.description.$error) return errors;
      !this.$v.currentCharge.description.required &&
        errors.push("Este campo es requerido");
      return errors;
    },
    category_chargeErrors: function() {
      const errors = [];
      if (!this.$v.currentCharge.category_charge.$error) return errors;
      !this.$v.currentCharge.category_charge.required &&
        errors.push("Este campo es requerido");
      return errors;
    },
    amountErrors: function() {
      const errors = [];
      if (!this.$v.currentCharge.amount.$error) return errors;
      !this.$v.currentCharge.amount.required &&
        errors.push("Este campo es requerido");
      return errors;
    }
  },
  methods: {
    saveCharge() {
      this.$emit("save-charge", this.currentCharge);
      this.$emit("close-dialog");
    }
  }
};
</script>
<style scoped>
@media (min-width: 960px) {
  .pull-right-on-desktop {
    display: flex;
    justify-content: flex-end;
  }
}
.bottom-bar {
  position: fixed;
  padding: 0 24px;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 88px;
  display: flex;
  justify-content: flex-end;
}
.pb24 {
  padding-bottom: 84px;
}
.pb0 {
  padding-bottom: 0;
}
.pt0 {
  padding-top: 0;
}
.p0 {
  padding: 0;
}
.m0 {
  margin: 0;
}
.date {
  text-transform: capitalize;
  text-align: left;
}
.status-name-cont {
  height: 30px;
  background: #c8272a;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 12px;
  text-transform: capitalize;
}
</style>
